import { get } from "lodash";

//User logged settings
const LOCAL_STORAGE_KEY = "SAVNOBOOK_CLIENT_USER";

const LOCAL_RESERVATION_KEY = "SAVNOBOOK_CURRENT_RESERVATION";

class LocalStorageClass {
   login(params) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(params));
   }

   logout() {
      localStorage.clear();
      localStorage.setItem(LOCAL_STORAGE_KEY, null);
      this.resetReservation(); //other user??
   }

   isLogged() {
      const item = this._parseJSONStorageItem(LOCAL_STORAGE_KEY);
      return item != null;
   }

   getToken() {
      return this.getField("token") ?? "";
   }

   setToken(token, expires_at) {
      const jsonItem = {
         ...this._parseJSONStorageItem(LOCAL_STORAGE_KEY),
         token,
         expires_at,
      };
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(jsonItem));
   }

   getRefreshToken() {
      return this.getField("refresh_token");
   }

   setRefreshToken(newRefreshToken) {
      var jsonItem = { ...this._parseJSONStorageItem(LOCAL_STORAGE_KEY) };
      jsonItem.refresh_token = newRefreshToken;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(jsonItem));
   }

   getField(key) {
      const jsonItem = this._parseJSONStorageItem(LOCAL_STORAGE_KEY);
      return get(jsonItem, key, null);
   }

   resetReservation() {
      localStorage.removeItem(LOCAL_RESERVATION_KEY);
   }

   setReservation(reservation) {
      if (reservation) {
         localStorage.setItem(LOCAL_RESERVATION_KEY, JSON.stringify(reservation));
      }
   }

   getReservation() {
      return this._parseJSONStorageItem(LOCAL_RESERVATION_KEY);
   }

   getReservationId() {
      const reservation = this.getReservation();
      if (reservation) return reservation.id;
      return null;
   }

   getReservationStatus() {
      const reservation = this.getReservation();
      if (reservation) return reservation.status;
      return null;
   }

   updateReservationStatus(status) {
      let reservation = this.getReservation();
      if (!reservation) return null;
      reservation.status = status;
      this.setReservation(reservation);
      return true;
   }

   _parseJSONStorageItem(key) {
      const item = localStorage.getItem(key);
      if (item) {
         try {
            return JSON.parse(item);
         } catch (e) {
            return null;
         }
      }
      return null;
   }
}

export const localStorageClass = new LocalStorageClass();
Object.freeze(localStorageClass); //Singleton
//
